export enum winCelebrationAssetConfig {

    bgRaysJson = "assets/winCelebration/Big_win.json",
    tickupFont = "assets/winCelebration/big_win_num-export.xml",
    coinsJson = "assets/winCelebration/coin.json",
    //tickup = "assets/font/celebration_win_num-export.xml",
    tickup1 = "assets/font/num_1-export.xml",
}